import layoutSelectors from 'src/modules/layout/layoutSelectors'
import React, { lazy, Suspense, useEffect, useRef } from 'react'
import { Route, Routes } from 'react-router-dom'
import PublicRoute from 'src/view/shared/routes/PublicRoute'
import CustomLoadable from 'src/view/shared/CustomLoadable'
import ProgressBar from 'src/view/shared/ProgressBar'
import routes from 'src/view/routes'
import authSelectors from 'src/modules/auth/authSelectors'
import LoadingComponent from 'src/view/shared/LoadingComponent'
import { useAppSelector } from 'src/modules/hooks'

function RoutesComponent(props) {
  const isInitialMount = useRef(true)

  // const authLoading = useSelector(authSelectors.selectLoadingInit)
  const layoutLoading = useAppSelector(layoutSelectors.selectLoading)
  const loading = layoutLoading
  const loggedInUser = useAppSelector(authSelectors.selectLoggedInUser)

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      ProgressBar.start()
      return
    }

    if (!loading) {
      ProgressBar.done()
    }
  }, [loading])

  if (loading) {
    return <div />
  }

  const PrivateRoute = lazy(() => import(/* HMITKOV: CHUNK */ 'src/view/shared/routes/PrivateRoute'))

  return (
    <Suspense fallback={<LoadingComponent />}>
      <Routes>
        {routes.publicRoutes.map((route: any) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PublicRoute
                currentUser={loggedInUser}
                component={route.component}
                allowsAuthenticatedUsers={route.allowsAuthenticatedUsers}
              />
            }
          />
        ))}

        {routes.privateRoutes.map((route: any) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PrivateRoute
                currentUser={loggedInUser}
                permissionRequired={route.permissionRequired}
                component={route.component}
              />
            }
          />
        ))}
        {routes.simpleRoutes.map((route: any) => {
          const Component = CustomLoadable({ loader: route.loader })
          return <Route key={route.path} path={route.path} element={<Component />} />
        })}
      </Routes>
    </Suspense>
  )
}

export default RoutesComponent
